import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { Button } from '@tis/shared-tis-ui';
import React from 'react';
import styles from '../Dialog.module.scss';

interface SignupSuccessDialogProps {
  onClose: (callback?: () => void) => void;
}

const SignupSuccessDialog: React.FC<SignupSuccessDialogProps> = ({
  onClose,
}) => {
  return (
    <>
      <DialogContent className={styles.dialogContent}>
        <div className={styles.dialogHeader}>
          <CheckCircleIcon className={styles.checkIcon} />
          <Typography
            component="h5"
            variant="h5"
            sx={{ fontSize: '20px', fontWeight: 'bold' }}
          >
            Account creation successful
          </Typography>
        </div>
        <Typography>
          A verification email has been sent to you. Please check your email
          inbox and select the link provided to log in.
        </Typography>
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button
          variant="outlined"
          onClick={() => {
            onClose(() => {
              window.location.href =
                import.meta.env.VITE_TIS_NATIONAL_BASE_URL || '/';
            });
          }}
        >
          Return to TIS National
        </Button>
      </DialogActions>
    </>
  );
};

export default SignupSuccessDialog;
